import React from "react";
import HeroSection from "../sections/HeroSection";
import AboutSection from "../sections/AboutSection";
import ResumeSection from "../sections/ResumeSection";
import ProjectsSection from "../sections/ProjectsSection";
import MetaTags from "../modules/MetaTags";
import AppointmentScheduler from "../modules/AppointmentScheduler";
import AppointmentModelButton from "../modules/AppointmentModelButton";
import Thought from "../modules/Thought";
import FAQSection from "../sections/FAQSection";

const HomePage = () => {
	return (
		<>
			<MetaTags />
			<HeroSection />
			<Thought text="Tired of tech clutter? I harness React.js and Node.js to build straightforward, scalable software that cuts through the noise. Let’s create impactful solutions that truly matter." />
			<AboutSection />
			<AppointmentScheduler />
			<ResumeSection />
			<AppointmentModelButton
				heading="Let's Create the Future Together"
				text="Inspired by these innovative solutions? Collaborate with Murtaza Lightwala to pioneer groundbreaking projects that stand out in the digital landscape."
				buttonText="Schedule a Consultation"
			/>
			<ProjectsSection />
			<FAQSection slug={"index"} />
		</>
	);
};

export default HomePage;
